import { useContext, useEffect } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';

import { ConsentContext, ConsentFlows } from '../context/ConsentContext';
import OnboardingLayout from '../ui/Layout/OnboardingLayout';
import LoginCard from '../ui/LoginCard';
import { getCurrentUserInfo } from '../utils/auth';

import {
  CannotConfirmContainer,
  CardDetailsContainer,
  ConnectingContainer,
  ErrorContainer,
  MeterCodeContainer,
  MoveDateContainer,
  MpanContainer,
  NotCompatibleContainer,
  SystemUnavailableContainer,
  VerifyContainer,
} from './SmartMeter';

const SmartMeterContainer = () => {
  const { setHasRegisterMpanTrustedConsent, setHasOnboarded, setUser, consentFlow, setConsentFlow } =
    useContext(ConsentContext);

  useEffect(() => {
    // re-initialise onboarding control vars
    setHasRegisterMpanTrustedConsent(false);
    setHasOnboarded(false);
    setConsentFlow(ConsentFlows.ONBOARDING);
    getCurrentUserInfo().then((res) => {
      if (res) {
        setUser(res);
      }
    });
  }, []);

  return (
    <OnboardingLayout>
      <LoginCard>
        <Routes>
          <Route index element={<Navigate to={`${consentFlow}/move-date`} replace />} />
          <Route path={`${consentFlow}/move-date`} element={<MoveDateContainer />} />
          <Route path={`${consentFlow}/mpan`} element={<MpanContainer />} />
          <Route path={`${consentFlow}/not-compatible`} element={<NotCompatibleContainer />} />
          <Route path={`${consentFlow}/verify-address`} element={<VerifyContainer />} />
          <Route path={`${consentFlow}/card-details`} element={<CardDetailsContainer />} />
          <Route path={`${consentFlow}/connecting`} element={<ConnectingContainer />} />
          <Route path={`${consentFlow}/cannot-confirm`} element={<CannotConfirmContainer />} />
          <Route path={`${consentFlow}/meter-code`} element={<MeterCodeContainer />} />
          <Route path={`${consentFlow}/error`} element={<ErrorContainer />} />
          <Route path={`${consentFlow}/system-unavailable`} element={<SystemUnavailableContainer />} />
          <Route path="*" element={<Navigate to="not-found" />} />
        </Routes>
      </LoginCard>
    </OnboardingLayout>
  );
};

export default SmartMeterContainer;
